/* WEELZ — Buy 2, get the third eligible item free + free shipping.
   The promotion itself remains Shopify's automatic discount. This script is a
   lightweight cart enhancement: it never changes prices or blocks checkout. */
(() => {
  const GROUP_SIZE = 3;
  const STYLE_ID = 'weelz-offer-style';
  const POPUP_ID = 'weelz-offer-popup';
  let refreshTimer;
  let activePopup = null;
  let previouslyFocused = null;

  const isArabic = () => document.documentElement.lang.toLowerCase().startsWith('ar');
  const copy = (cart) => {
    const remainder = cart.item_count % GROUP_SIZE;
    const freeCount = Math.floor(cart.item_count / GROUP_SIZE);
    const toNext = GROUP_SIZE - remainder;
    const ar = isArabic();
    if (remainder === 0) {
      return {
        state: 'active',
        pct: 100,
        text: ar
          ? `🎉 تم تفعيل العرض: ${freeCount === 1 ? 'أرخص قطعة مجانية' : freeCount + ' قطع مجانية'} + شحن مجاني`
          : `🎉 Offer active: ${freeCount === 1 ? 'the lowest-priced item is free' : freeCount + ' items are free'} + free delivery`,
      };
    }
    const quantity = toNext === 1 ? (ar ? 'قطعة واحدة' : '1 item') : (ar ? 'قطعتين' : '2 items');
    const reward = freeCount > 0
      ? (ar ? 'قطعة مجانية إضافية' : 'another free item')
      : (ar ? 'القطعة الثالثة مجاناً' : 'your third item free');
    return {
      state: 'progress',
      pct: Math.round((remainder / GROUP_SIZE) * 100),
      text: ar
        ? `🎁 أضف ${quantity} لتحصل على ${reward} · شحن مجاني`
        : `🎁 Add ${quantity} to unlock ${reward} · free delivery`,
    };
  };

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .weelz-offer-bar{margin:0;padding:13px 16px;background:#f3faf5;border-bottom:1px solid #e2efe6;font-family:'Shubbak',Arial,sans-serif}
      .weelz-offer-bar__msg{font-size:.84rem;font-weight:700;line-height:1.45;color:#0c6b30;margin:0 0 8px}
      .weelz-offer-bar__track{height:7px;background:#dcece2;border-radius:99px;overflow:hidden}
      .weelz-offer-bar__fill{display:block;height:100%;width:0;background:#0c873b;border-radius:99px;transition:width .45s cubic-bezier(.22,1,.36,1)}
      .weelz-offer-bar[data-state="active"]{background:#eaf7ee}
      .weelz-offer-popup{position:fixed;z-index:2147483000;inset:0;display:grid;place-items:center;padding:20px;background:rgba(10,20,14,.42);opacity:0;visibility:hidden;transition:opacity .24s ease,visibility 0s linear .24s}
      .weelz-offer-popup.is-open{opacity:1;visibility:visible;transition:opacity .24s ease}
      .weelz-offer-popup__dialog{width:min(100%,440px);position:relative;background:#fff;border:1px solid rgba(12,135,59,.16);border-radius:16px;box-shadow:0 22px 60px rgba(0,0,0,.22);padding:28px;transform:translateY(16px) scale(.97);opacity:0;transition:transform .34s cubic-bezier(.22,1,.36,1),opacity .22s ease}
      .weelz-offer-popup.is-open .weelz-offer-popup__dialog{transform:translateY(0) scale(1);opacity:1}
      .weelz-offer-popup__eyebrow{display:inline-flex;align-items:center;gap:8px;color:#0c873b;font-size:.78rem;font-weight:800;letter-spacing:.03em;margin:0 0 10px}
      .weelz-offer-popup__eyebrow::before{content:'';width:8px;height:8px;border-radius:50%;background:#0c873b;box-shadow:0 0 0 5px rgba(12,135,59,.12)}
      .weelz-offer-popup__title{margin:0;color:#111;font-size:1.48rem;line-height:1.2;font-weight:800}
      .weelz-offer-popup__text{margin:10px 0 20px;color:#505050;line-height:1.55;font-size:.96rem}
      .weelz-offer-popup__actions{display:grid;grid-template-columns:1fr 1fr;gap:10px}
      .weelz-offer-popup__button{appearance:none;min-height:48px;padding:10px 14px;border-radius:8px;font:700 .92rem/1 'Shubbak',Arial,sans-serif;cursor:pointer;transition:transform .16s ease,background .16s ease,box-shadow .16s ease}
      .weelz-offer-popup__button:focus-visible,.weelz-offer-popup__close:focus-visible{outline:3px solid rgba(12,135,59,.32);outline-offset:2px}
      .weelz-offer-popup__button--primary{border:1px solid #0c873b;background:#0c873b;color:#fff}
      .weelz-offer-popup__button--primary:hover{background:#0a6f30;box-shadow:0 8px 18px rgba(12,135,59,.2);transform:translateY(-1px)}
      .weelz-offer-popup__button--secondary{border:1px solid #d9ded9;background:#fff;color:#111}
      .weelz-offer-popup__button--secondary:hover{background:#f5f8f5}
      .weelz-offer-popup__close{position:absolute;top:12px;inset-inline-end:12px;width:34px;height:34px;border:0;border-radius:50%;background:transparent;color:#444;font:400 28px/1 Arial;cursor:pointer}
      .weelz-offer-popup__close:hover{background:#f2f4f2}
      @media (max-width:480px){.weelz-offer-popup{align-items:end;padding:12px}.weelz-offer-popup__dialog{width:100%;border-radius:16px;padding:26px 20px 20px}.weelz-offer-popup__actions{grid-template-columns:1fr}.weelz-offer-popup__button--primary{order:-1}}
      @media (prefers-reduced-motion:reduce){.weelz-offer-bar__fill,.weelz-offer-popup,.weelz-offer-popup__dialog,.weelz-offer-popup__button{transition:none!important}}
    `;
    document.head.appendChild(style);
  }

  function ensureBar(host) {
    let bar = host.querySelector(':scope > .weelz-offer-bar');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'weelz-offer-bar';
      bar.innerHTML = '<p class="weelz-offer-bar__msg"></p><div class="weelz-offer-bar__track"><span class="weelz-offer-bar__fill"></span></div>';
      host.prepend(bar);
    }
    return bar;
  }

  function renderProgress(cart) {
    const info = cart.item_count ? copy(cart) : null;
    const drawers = Array.from(document.querySelectorAll('theme-drawer .theme-drawer__dialog'))
      .filter((drawer) => drawer.querySelector('cart-drawer-component'));
    const page = Array.from(document.querySelectorAll('.cart-page,.main-cart,#main-cart')).slice(0, 1);
    drawers.concat(page).forEach((host) => {
      const existing = host.querySelector(':scope > .weelz-offer-bar');
      if (!info) {
        if (existing) existing.remove();
        return;
      }
      const bar = ensureBar(host);
      bar.dataset.state = info.state;
      bar.querySelector('.weelz-offer-bar__msg').textContent = info.text;
      bar.querySelector('.weelz-offer-bar__fill').style.width = info.pct + '%';
    });
  }

  function popup() {
    let root = document.getElementById(POPUP_ID);
    if (root) return root;
    root = document.createElement('div');
    root.id = POPUP_ID;
    root.className = 'weelz-offer-popup';
    root.hidden = true;
    root.innerHTML = `
      <div class="weelz-offer-popup__dialog" role="dialog" aria-modal="true" aria-labelledby="weelz-offer-popup-title" aria-describedby="weelz-offer-popup-text">
        <button class="weelz-offer-popup__close" type="button" aria-label="Close">×</button>
        <p class="weelz-offer-popup__eyebrow"></p>
        <h2 class="weelz-offer-popup__title" id="weelz-offer-popup-title"></h2>
        <p class="weelz-offer-popup__text" id="weelz-offer-popup-text"></p>
        <div class="weelz-offer-popup__actions">
          <button class="weelz-offer-popup__button weelz-offer-popup__button--primary" type="button" data-weelz-offer-shop></button>
          <button class="weelz-offer-popup__button weelz-offer-popup__button--secondary" type="button" data-weelz-offer-cart></button>
        </div>
      </div>
    `;
    root.addEventListener('click', (event) => {
      if (event.target === root || event.target.closest('.weelz-offer-popup__close')) closePopup();
      if (event.target.closest('[data-weelz-offer-shop]')) closePopup();
      if (event.target.closest('[data-weelz-offer-cart]')) window.location.assign('/cart');
    });
    document.body.appendChild(root);
    return root;
  }

  function closePopup() {
    if (!activePopup) return;
    activePopup.classList.remove('is-open');
    const target = activePopup;
    activePopup = null;
    window.setTimeout(() => { target.hidden = true; }, 240);
    if (previouslyFocused && document.contains(previouslyFocused)) previouslyFocused.focus();
  }

  function openPopup(cart) {
    const remainder = cart.item_count % GROUP_SIZE;
    if (!cart.item_count || remainder === 0) return;
    const key = 'weelz-offer-popup:' + (cart.token || 'cart') + ':' + cart.item_count;
    try {
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, '1');
    } catch (_) {}

    const ar = isArabic();
    const oneAway = remainder === 2;
    const root = popup();
    root.querySelector('.weelz-offer-popup__close').setAttribute('aria-label', ar ? 'إغلاق' : 'Close');
    root.querySelector('.weelz-offer-popup__eyebrow').textContent = ar ? 'عرض WEELZ' : 'WEELZ OFFER';
    root.querySelector('.weelz-offer-popup__title').textContent = oneAway
      ? (ar ? 'فاضل قطعة واحدة على هديتك' : 'One more item unlocks your gift')
      : (ar ? 'ابدأ العرض بثالث قطعة مجاناً' : 'Start your third-item-free offer');
    root.querySelector('.weelz-offer-popup__text').textContent = oneAway
      ? (ar ? 'أضف قطعة مؤهلة الآن، ويُطبّق خصم الأرخص تلقائياً عند إتمام الطلب.' : 'Add one eligible item now. The lowest-priced eligible item is discounted automatically at checkout.')
      : (ar ? 'أضف قطعتين مؤهلتين إضافيتين، وتحصل على الأرخص مجاناً مع شحن مجاني.' : 'Add two more eligible items and the lowest-priced one is free, with free delivery.');
    root.querySelector('[data-weelz-offer-shop]').textContent = ar ? 'تسوّق المزيد' : 'Keep shopping';
    root.querySelector('[data-weelz-offer-cart]').textContent = ar ? 'عرض السلة' : 'View cart';
    previouslyFocused = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    root.hidden = false;
    requestAnimationFrame(() => root.classList.add('is-open'));
    activePopup = root;
    root.querySelector('.weelz-offer-popup__close').focus();
  }

  function refresh({ showPopup = false } = {}) {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(() => {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then((response) => response.ok ? response.json() : Promise.reject())
        .then((cart) => {
          renderProgress(cart);
          if (showPopup) openPopup(cart);
        })
        .catch(() => {});
    }, 120);
  }

  function interceptCartRequests() {
    const originalFetch = window.fetch;
    if (originalFetch.__weelzOfferWrapped) return;
    function wrappedFetch(...args) {
      const response = originalFetch.apply(this, args);
      try {
        let url = args[0];
        if (url && typeof url === 'object' && url.url) url = url.url;
        if (typeof url === 'string' && /\/cart\/(add|change|update|clear)(?:\.js)?(?:\?|$)/.test(url)) {
          const isAdd = /\/cart\/add(?:\.js)?(?:\?|$)/.test(url);
          response.then(() => refresh({ showPopup: isAdd })).catch(() => {});
        }
      } catch (_) {}
      return response;
    }
    wrappedFetch.__weelzOfferWrapped = true;
    window.fetch = wrappedFetch;
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closePopup();
  });
  document.addEventListener('shopify:section:load', () => refresh());
  function init() {
    injectStyles();
    interceptCartRequests();
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
